module.exports = __webpack_public_path__ + "img/homepage_3--mobile@2x.216ed849.jpg";